import React,{useRef, useState, useEffect, useContext, useCallback} from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button, Badge, InputGroup, Alert, Dropdown, Modal } from "react-bootstrap";
import {setUrlParam } from "../utils/functions";
import Select from "react-select";
import Footer from "../layouts/Footer";
import Sidebar from "../layouts/Sidebar";
import Header from "../layouts/Header";
import parse from 'html-react-parser';
import {projectPhaseColors, projectStatusColors} from "../data/ProjectStatusColor";
import energyTypes from "../data/energyTypes";
import atlasApi from "../utils/atlasapi";
import authApi from "../utils/authApi";
import Loader from "../components/Loader";
import Filter from "../components/Filter";
import UserMenu		from "../components/UserMenu";
import {formatDate} from  "../utils/functions";
import DialogScreeningMap from "../layouts/DialogScreeningMap";
import InfoLayers from "../components/InfoLayers";
import {drawUtils} from "../utils/drawUtils";
import drawTheme from "../utils/drawUtilsTheme";
import boundaryMode from "../utils/boundaryMode";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import turbineControl from "../utils/turbineControl";
import limited_simple_select from "../utils/simple_select";
import limited_direct_select from "../utils/direct_select";
import DialogProject from "../layouts/DialogProject";
import TurfBBox from '@turf/bbox';
import TurfArea from '@turf/area';
import { findInvalidity, fixSelfIntersections } from "../utils/geometry";
import ScreeningOverlay from "../components/screening/ScreeningOverlay";
import CadastralOverlay from "../components/cadastral/CadastralOverlay";
import { NewProjectMenu, NewProjectHeader, MethodPanel, CreateFooter, InvalidShape } from "../components/newproject/NewProject";
import UploadMethod from "../components/newproject/UploadMethod";
import EditNow from "../components/EditNow";
import globalContext				from "../utils/globalContext";

import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

import key from '../data/mapboxKey'; // eslint-disable-line import/no-webpack-loader-syntax


var tc,du, selectedMap;	//Turbine control

/* Areal (ha) og antall hjoernepunkter for omrisset i tegnelaget. */
const shapeStats = (geometry) => {
	const rings = geometry.type === 'MultiPolygon' ? geometry.coordinates.map((p) => p[0]) : [geometry.coordinates[0]];
	return {
		points: rings.reduce((n, r) => n + Math.max(r.length - 1, 0), 0),
		ha: TurfArea(geometry) / 10000,
		...findInvalidity(geometry)
	};
}
const isInvalid = (s) => !!(s && (s.kinks.length || s.overlaps));

/* Kryssingspunktene i et ugyldig omriss markeres i kartet. */
const KINKS_SOURCE = 'np-kinks';
const showKinks = (map, points) => {
	if(!map || !map.isStyleLoaded())
		return;
	const data = {type:'FeatureCollection', features: points.map((c) => ({type:'Feature', properties:{}, geometry:{type:'Point', coordinates:c}}))};
	if(map.getSource(KINKS_SOURCE)){
		map.getSource(KINKS_SOURCE).setData(data);
		return;
	}
	if(!points.length)
		return;
	map.addSource(KINKS_SOURCE, {type:'geojson', data:data});
	map.addLayer({
		id: KINKS_SOURCE,
		type: 'circle',
		source: KINKS_SOURCE,
		paint: {
			'circle-radius': 7,
			'circle-color': '#D92D20',
			'circle-stroke-color': '#ffffff',
			'circle-stroke-width': 2
		}
	});
}
const formatHa = (ha) => Number(ha || 0).toLocaleString(undefined, {maximumFractionDigits: ha < 100 ? 1 : 0});

export default function SandboxMap() {
	
	document.body.className="sandboxmap";
		
	const [loaded,setLoaded]							= useState(false); //status variable set when all data is loaded
	const [mapLoaded,setMapLoaded]						= useState(false); //status variable set when all data is loaded
	const [user,setUser]								= useState(false);
	const [shape, setShape]								= useState(null); //project outline in the draw layer: {source: draw | upload, points, ha}
	const [drawing, setDrawing]							= useState({active:false, points:0, ha:0, kinks:[]}); //live stats while a shape is being drawn
	const [saveProjectDialog, setSaveProjectDialog]		= useState({open:false}); //displays save project dialog
	const [method, setMethod]							= useState(null); //active method in the New project panel: screen | draw | cad | upload (null = panel closed)
	const [dirty, setDirty]								= useState({screen:false, cad:false}); //unsaved selections in the screening / cadastral tabs
	const [panelKey, setPanelKey]						= useState(0); //bumped when the panel closes, so the tabs start empty next time
	const [confirmClose, setConfirmClose]				= useState(false); //displays the "discard unsaved work" dialog
	const [focusEntry, setFocusEntry]					= useState(false); //return focus to the New project button after closing the panel
	const params										= useParams();
	
	const context = useContext(globalContext);

	const center = [25.50, 42.70]; //Bulgaria
	const zoom = 6.8;


	const mapCont										= useRef(null);
	const drawBtn										= useRef(null);
	const infoLayerPanel								= useRef(null);
	const map											= useRef(null);



	MapboxDraw.modes.simple_select = {...MapboxDraw.modes.simple_select, ...limited_simple_select};
	MapboxDraw.modes.direct_select = {...MapboxDraw.modes.direct_select, ...limited_direct_select};

	const Draw = new MapboxDraw({
		displayControlsDefault: false,
		controls: {
			polygon: false,
			line_string:false,
			trash: false,
			boundary_mode:true
		},
		userProperties:true,
		styles: drawTheme,
		modes: Object.assign({
			boundary_mode: boundaryMode,
		}, MapboxDraw.modes)
	});

	
	
	const getCopy = () => {
		return JSON.parse(JSON.stringify(this.state.items));
	}

	const getData = () => {

		const id = params.id;

		
		Promise.all([atlasApi.getToken()])
		.then((res) => {
			 
			const dataRequests = [
				authApi.getUser()
			];
			
			return Promise.all(dataRequests);
		}).then((res)=>{
			
			const dataRequests = [
				res[0],
				atlasApi.getUserMaps(res[0].userDetails)
			];
			
			return Promise.all(dataRequests);
		}).then((res)=>{
			
			const sandbox = res[1].find((a)=>{return a.id == id});
			
			
			setUser(res[0]);
			selectedMap = sandbox;
			renderMap();
			setLoaded(true);
			
			document.title = sandbox.title + ' - ' + process.env.REACT_APP_DOC_TITLE;

		}).catch((e)=>{
			setLoaded(true);

		});
		return;

		
	}

	const handleNew = (newMap) => {
		
		var swap = this.getCopy();
		swap.unshift(newMap);
		
		this.updateStatus({items:swap});
	}
	
	const handleUpdate = (id, newTitle) => {
		var swap = this.getCopy();
		var idx = swap.findIndex((i)=>{return i.id == id});

		if(idx != -1){
			swap[idx].title = newTitle;
			this.updateStatus({items:swap});
			atlasApi.updateUserMap(swap[idx]);
		}
	}
	const handleCloseMap = () => {
		this.updateStatus({selectedMap:null, map:null});
		
	}
	const handleDropDownClick = (e) => {
		e.stopPropagation();
	}
	const handleDuplicate = (item) => {
		
		
		Promise.all([atlasApi.duplicateUserMap(item)])
		.then((res) => {
			
			if(Array.isArray(res) && res.length && res[0].id)
				this.handleNew(res[0]);
			
			
		}).catch((e)=>{

		});
		
	}
	const handleDelete = (item) => {
		
		Promise.all([atlasApi.deleteUserMap(item)])
		.then((res) => {
			var swap = getCopy();
			var idx = swap.findIndex((i)=>{return i.id == item.id});
		
			if(idx != -1){
				swap.splice(idx, 1);
				this.updateStatus({items:swap});
			}
			
		}).catch((e)=>{

		});
		
	}
	const updateMapSettings = (newSettings) => {
		if(!selectedMap)
			return;
		
		var newMap = {...selectedMap, ...newSettings};
		
		selectedMap = newMap;
		
		atlasApi.updateUserMap(newMap);

	}

	const renderMap = () => {
		
		if(map.current)
			return;
		
		var self = this;
		map.current = new mapboxgl.Map({
			container: mapCont.current,
			style: 'mapbox://styles/espenvindr/cljhhkw0z000901pq5tql7ice',
			center: center,
			zoom: zoom,
		});
		
		map.current.addControl(Draw, 'bottom-left');
		
		map.current.dragRotate.disable();
		
		/* context maa med: hoeyreklikk-popupen viser en kvittering gjennom
		   QuickNote naar koordinaten kopieres. */
		du		= new drawUtils(map.current, Draw, context);
		tc		= new turbineControl(map.current, du);
		
		context.tc = tc;
		/* Popupen leser lagene sine herfra, som paa prosjektkartet. */
		tc.infoLayers = infoLayerPanel;
		
		map.current.on('draw.create', (e)=>{setShape({source:'draw', ...shapeStats(e.features[0].geometry)})});
		map.current.on('draw.delete', (e)=>{setShape(null)});
		const refreshShape = ()=>{
			const f = du.draw.getAll().features[0];
			setShape((s) => (s && f ? {...s, ...shapeStats(f.geometry)} : s));
		};
		map.current.on('draw.update', refreshShape);
		map.current.on('draw.updatevertex', refreshShape);
		map.current.on('boundary.progress', (e)=>{
			const n = e.coordinates.length;
			const ring = {type:'Polygon', coordinates:[[...e.coordinates, e.coordinates[0]]]};
			/* Kryssingssjekken er kvadratisk i antall punkter. Frihaandstegning gir
			   hundrevis av punkter per drag, saa underveis sjekkes bare korte
			   omriss; hele figuren sjekkes uansett naar den lukkes (draw.create). */
			setDrawing((d) => ({
				active: true,
				points: n,
				ha: n >= 3 ? TurfArea(ring) / 10000 : 0,
				kinks: n < 4 ? [] : n <= 150 ? findInvalidity(ring).kinks : d.kinks
			}));
		});
		map.current.on('boundary.stop', ()=>{setDrawing((d) => ({...d, active:false}))});
		map.current.on('draw.modechange', (e)=>{du.handleModeChange(e);});
		
		map.current.on('load', () => {
			
			setMapLoaded(true);
			showSandbox();
		});
		
		
		
		
	}
	const showSandbox = () => {
		if(!selectedMap)
			return;
		
		var target = {};
		
		if(!isNaN(selectedMap.settings.lng) && !isNaN(selectedMap.settings.lat))
			target = {center:[selectedMap.settings.lng, selectedMap.settings.lat]};
		if(!isNaN(selectedMap.settings.zoom))
			target = {...target, ...{ zoom:selectedMap.settings.zoom}};
		
		if(target.center)
			map.current.setCenter(target.center).setZoom(target.zoom);
		
		
		
		map.current.once('zoomend', () => {
			map.current.on('zoomend', () => {
				var settings = {
					...selectedMap.settings, 
					...{zoom:map.current.getZoom()}
				};
				updateMapSettings({...selectedMap, ...{settings: settings}});
			});
			map.current.on('dragend', () => {
				var coords = map.current.getCenter();
				var settings = {
					...selectedMap.settings, 
					...coords
				};
				updateMapSettings({...selectedMap, ...{settings: settings}});
			});
		});
	}
	const startDrawing = () => {
		if(!tc || !du)
			return;
		du.draw.deleteAll();
		setShape(null);
		setDrawing({active:true, points:0, ha:0, kinks:[]});
		/* addProject markerer knappen som startet tegningen; uten et klikk
		   (fanen aapnes) gir vi den knappen selv. */
		tc.addProject({target: drawBtn.current});
	}
	const clearShape = () => {
		if(tc)
			tc.exit();
		if(du)
			du.draw.deleteAll();
		setShape(null);
	}
	// Same fix as "Flatten polygon" on the project boundary: split at the
	// crossings and merge the pieces into one valid outline.
	const fixShape = () => {
		const f = du && du.draw.getAll().features[0];
		if(!f)
			return;
		const geometry = fixSelfIntersections(f.geometry);
		du.draw.deleteAll();
		du.draw.add({type:'Feature', id:'boundary', properties:f.properties || {}, geometry:geometry});
		setShape((s) => (s ? {...s, ...shapeStats(geometry)} : s));
	}
	const undoPoint = () => {
		if(map.current)
			map.current.fire('boundary.undo');
	}

	/* ---- New project panel ---- */
	const changeMethod = (m) => {
		if(method === 'draw' && m !== 'draw' && tc)
			tc.exit();
		setMethod(m);
	}
	const closePanel = () => {
		setConfirmClose(false);
		clearShape();
		setDirty({screen:false, cad:false});
		setPanelKey((k) => k + 1);
		setMethod(null);
		setFocusEntry(true);
	}
	const requestClosePanel = () => {
		if(dirty.screen || dirty.cad || shape)
			setConfirmClose(true);
		else
			closePanel();
	}
	const handleScreenDirty = useCallback((v) => setDirty((d) => ({...d, screen:v})), []);
	const handleCadDirty = useCallback((v) => setDirty((d) => ({...d, cad:v})), []);

	const openSaveProject = (b) => {
		setSaveProjectDialog({open:true, boundary:b});
	}
	const closeSaveProject = () => {
		setSaveProjectDialog({open:false});
	}
	
	const handleSaveProject = (e) => {
		
		var fc = du.draw.getAll();
		
		if(!fc.features || !fc.features.length)
			return;
		
		var b = {...fc.features[0].geometry};
		
		if(fc.features[0].geometry.type != 'MultiPolygon'){
			b.type = 'MultiPolygon';
			b.coordinates = [fc.features[0].geometry.coordinates];
		}
		openSaveProject(b);
	}
	
	const handleUploadedShape = (feature, info) => {
		
		if(!du)
			return;
		
		feature = {...feature, id:'boundary'};
		
		du.draw.deleteAll();
		du.draw.add(feature);
		setShape({source:'upload', ...info, ...shapeStats(feature.geometry)});
		map.current.fitBounds(TurfBBox(feature), {padding:{top:60, bottom:60, left:60, right:460}, duration:700});
		
	}
	const renderLayers = () => {
		if(!mapLoaded)
			return;
		return (
			<div className="nav-group project-panel show">
				<div id="layers" className="layer-section	mt-3">
					 <InfoLayers ref={infoLayerPanel} context={context} scenario={{layers:selectedMap.layers, scenario_id:0}} onChange={(payload)=>{updateMapSettings({layers:payload})}} user={user} map={map}  />
				</div>
			</div>
		 );
	}



	const header = method ? <NewProjectHeader method={method} onChange={changeMethod} onClose={requestClosePanel} /> : null;

	useEffect(()=>{
		getData();
	},[]);

	// Mark where the outline crosses itself, while drawing and once it is done
	useEffect(()=>{
		if(!mapLoaded)
			return;
		const points = drawing.active ? drawing.kinks
			: (method === 'draw' || method === 'upload') && shape ? shape.kinks : [];
		showKinks(map.current, points);
	},[mapLoaded, drawing, shape, method]);

	// Draw tab: start drawing right away when there is no shape yet
	useEffect(()=>{
		if(method === 'draw' && mapLoaded && !shape)
			startDrawing();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[method, mapLoaded]);
	
	
	return (
		<>


			<div className="header">

				<div className="menu">
					<i className="ri-menu-2-fill"></i>
				</div>



				<div className="middle">
					{!!selectedMap &&
					<Link className="header-logo">{selectedMap.title}</Link>
					}

				</div>

				<div className="logo">
					<img className="img-fluid d-none d-md-block brand-logo" src="/images/allod_atlas_logo.png" alt="Allod"/>
				</div>
				<div className="options">
					<Link to="/pages/sandbox/" className="btn btn-outline-primary">Close</Link>
					
					
				</div>
			</div>
			<div className="body">
				<Sidebar onClick={(e)=>{ e.stopPropagation();}} add={renderLayers()} hideMenu={true} />
				<div className={"main sandbox "}>
					<Row className="mb-4">
						<Col xl>

						</Col>
					</Row>

					<div ref={mapCont}	className="project-map" >

						{!method && (
							<div className="np-entry-wrap">
								<NewProjectMenu onPick={(m) => { setFocusEntry(false); setMethod(m); }} autoFocus={focusEntry} />
							</div>
						)}

						<ScreeningOverlay
							key={'screen-'+panelKey}
							map={map.current}
							mapReady={mapLoaded}
							visible={method === 'screen'}
							fitOnShow={true}
							baseLayers={false}
							fitPadding={{top:60, bottom:60, left:60, right:460}}
							header={header}
							onDirtyChange={handleScreenDirty}
						/>

						<CadastralOverlay
							key={'cad-'+panelKey}
							map={map.current}
							mapReady={mapLoaded}
							visible={method === 'cad'}
							fitPadding={{top:60, bottom:120, left:60, right:460}}
							onCreate={openSaveProject}
							header={header}
							onDirtyChange={handleCadDirty}
						/>

						{method === 'draw' && (
							<MethodPanel
								header={header}
								footer={shape && shape.source === 'draw' && !drawing.active && (
									<CreateFooter
										title={isInvalid(shape) ? "Invalid shape" : "Shape drawn"}
										meta={isInvalid(shape) ? "Fix the outline to create the project" : `${formatHa(shape.ha)} ha total · ${shape.points} points`}
										onClear={startDrawing}
										onCreate={handleSaveProject}
										disabled={isInvalid(shape)}
									/>
								)}>
								<div className="np-hint">
									<b>Click on the map</b> to add corners. Click the first point or double-click to close the shape. You can also hold and drag to draw freehand.
									<div className="np-keys">Backspace removes the last point · Esc cancels</div>
								</div>
								{shape && shape.source === 'upload' && !drawing.active && (
									<div className="np-status warn">The file from Upload is on the map. Drawing a shape replaces it.</div>
								)}
								{drawing.active && drawing.kinks.length > 0 && (
									<div className="np-status warn">The lines cross each other (marked in red). Undo the last point, or keep drawing and fix the shape when it is closed.</div>
								)}
								{shape && shape.source === 'draw' && !drawing.active && isInvalid(shape) && (
									<InvalidShape shape={shape} onFix={fixShape} />
								)}
								<div className="np-stats">
									<div className="np-stat">
										<div className="lbl">Area</div>
										<div className="v">{formatHa(drawing.active ? drawing.ha : shape && shape.source === 'draw' ? shape.ha : 0)} ha</div>
									</div>
									<div className="np-stat">
										<div className="lbl">Points</div>
										<div className="v">{drawing.active ? drawing.points : shape && shape.source === 'draw' ? shape.points : 0}</div>
									</div>
								</div>
								{/* Raden skjules naar figuren er ferdig (Clear i bunnlinjen tar over),
								    men knappen blir i DOM-en: tegneverktoeyet trenger den naar det startes. */}
								<div className="np-actions" hidden={!!(shape && shape.source === 'draw' && !drawing.active)}>
									<button className="btn btn-outline" onClick={undoPoint} disabled={!drawing.active || drawing.points === 0}>Undo point</button>
									<button ref={drawBtn} className="btn btn-outline" onClick={startDrawing}>
										{drawing.active ? 'Clear' : 'Start drawing'}
									</button>
								</div>
							</MethodPanel>
						)}

						{method === 'upload' && (
							<UploadMethod
								header={header}
								mapElement={mapCont.current}
								shape={shape}
								onShape={handleUploadedShape}
								onFix={fixShape}
								onClear={clearShape}
								onSave={handleSaveProject}
							/>
						)}

						<Modal show={confirmClose} onHide={() => setConfirmClose(false)} centered>
							<Modal.Header closeButton>
								<Modal.Title>Discard new project?</Modal.Title>
							</Modal.Header>
							<Modal.Body>You have selections that are not saved as a project yet. Closing the panel discards them.</Modal.Body>
							<Modal.Footer>
								<Button variant="light" onClick={() => setConfirmClose(false)}>Keep working</Button>
								<Button variant="danger" onClick={closePanel}>Discard</Button>
							</Modal.Footer>
						</Modal>

						<DialogProject user={user} state={saveProjectDialog} onClose={closeSaveProject} />

					</div>


				</div>


			</div>
			<Loader loaded={loaded} message="Loading project..." />
		</>
	);
	
}